'use strict';

var Utils = require('../utils/utils');
var Truncate = require('./lib/truncate');

// Constructor
var Linked = function() {

  var self = this;

  self.config = {
    'description'  :  '.linked__description'
  }

  self.init = function() {

    var largeViewports = function() {
      new Truncate(self.config).destroy();
    };

    var smallViewports = function() {
      new Truncate(self.config).init();
    };

    new Utils().matchmediaHandler('SMALLER', largeViewports, smallViewports);
  }
};

module.exports = Linked;
